var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { monthKeyOf } from "./volumeWindow";
var RECEIVED_STATUSES = new Set(["RECEIVED", "ARCHIVED"]);
// keyed by year too: a volume can span two calendar years (September 2026 - August 2027)
export function computeMonthlyStats(issues) {
    var stats = new Map();
    var dated = issues
        .filter(function (issue) { return issue.expectedDate; })
        .sort(function (a, b) { return a.expectedDate.localeCompare(b.expectedDate); });
    dated.forEach(function (issue) {
        var _a;
        var month = monthKeyOf(issue.expectedDate);
        var stat = (_a = stats.get(month.key)) !== null && _a !== void 0 ? _a : __assign(__assign({}, month), { expected: 0, received: 0 });
        stat.expected += 1;
        if (issue.libraryStatus && RECEIVED_STATUSES.has(issue.libraryStatus)) {
            stat.received += 1;
        }
        stats.set(month.key, stat);
    });
    return stats;
}
